import React from 'react';

const DIGITAL_MARKETING_LOGOS = [
  '/assets/images/digital-marketing/alex-design-studio.webp',
  '/assets/images/digital-marketing/bahama-museum.webp',
  '/assets/images/digital-marketing/dalton.webp',
  '/assets/images/digital-marketing/huston.webp',
  '/assets/images/digital-marketing/jacksmith.webp',
  '/assets/images/digital-marketing/nickjohn.webp',
  '/assets/images/digital-marketing/skylight.webp'
];

// Replicate array to enable seamless, infinite looping marquee
const extendedLogos = [
  ...DIGITAL_MARKETING_LOGOS,
  ...DIGITAL_MARKETING_LOGOS,
  ...DIGITAL_MARKETING_LOGOS,
  ...DIGITAL_MARKETING_LOGOS
];

function DigitalMarketingLogosSlider() {
  return (
    <section className="dig-logos-slider-section">
      <div className="dig-logos-slider-wrapper">
        {/* Edge Fade Gradients for Luxury Black Look */}
        <div className="dig-logos-fade-left"></div>
        <div className="dig-logos-fade-right"></div>

        <div className="dig-logos-marquee-container">
          <div className="dig-logos-marquee-track">
            {extendedLogos.map((logoSrc, idx) => (
              <div className="dig-logo-item" key={idx}>
                <img 
                  src={logoSrc} 
                  alt={`Partner Brand Logo ${(idx % DIGITAL_MARKETING_LOGOS.length) + 1}`} 
                  className="dig-logo-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingLogosSlider;
